import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    // 1. Verificamos si la sesión está vigente (menos de 12 horas)
    // isAuthenticated() también hará el logout automático si caducó
    if (!this.authService.isAuthenticated()) {
      this.router.navigate(['/login'], { replaceUrl: true });
      return false;
    }

    const roleOriginal = this.authService.getRol();

    // Si por alguna razón no hay rol guardado, a login
    if (!roleOriginal) {
      this.authService.logout();
      return false;
    }

    const userRole = roleOriginal.toLowerCase();
    const rolesPermitidos = route.data['roles'] as Array<string>; 

    // 2. El Administrador tiene acceso total
    if (userRole.includes('admin') || userRole.includes('administrador')) {
      return true;
    }

    // 3. Verificamos si el rol del usuario está en la lista de permitidos
    if (rolesPermitidos) {
      const tienePermiso = rolesPermitidos.some(rolPermitido => 
        userRole.includes(rolPermitido.toLowerCase())
      );
      if (tienePermiso) return true;
    }

    // 4. Si intentan entrar a una URL prohibida, redirigimos
    this.redirigirPorRol(userRole);
    return false;
  }

  private redirigirPorRol(rol: string) {
    if (rol.includes('tecnico')) this.router.navigate(['/dashboard-page'], { replaceUrl: true }); // Redirigir al dashboard en lugar de a '/tecnico' si no existe
    else if (rol.includes('vendedor')) this.router.navigate(['/dashboard-page'], { replaceUrl: true });
    else if (rol.includes('almacen')) this.router.navigate(['/dashboard-page'], { replaceUrl: true });
    else this.router.navigate(['/home'], { replaceUrl: true });
  }
}